// eslint-disable-next-line import/prefer-default-export
export const getBounds = (coordinatesArray = []) => {
  const initialCoordinates = coordinatesArray[0];

  const corners = coordinatesArray.reduce(
    ({ north, south, east, west }, coordinates) => ({
      north: Math.max(north, coordinates.latitude),
      south: Math.min(south, coordinates.latitude),
      east: Math.max(east, coordinates.longitude),
      west: Math.min(west, coordinates.longitude),
    }),
    {
      north: initialCoordinates.latitude,
      south: initialCoordinates.latitude,
      east: initialCoordinates.longitude,
      west: initialCoordinates.longitude,
    }
  );

  return [
    [corners.west, corners.south],
    [corners.east, corners.north],
  ];
};
